import { Controller } from 'stimulus';
import hasHistorySupport from '../helpers/hasHistorySupport';
import debounce from '../helpers/debounce';

class FilterController extends Controller {
  connect() {
    this.API_URL = this.data.get('api');
    this.parameters = {};

    if (this.searchTarget.value.length > 0) {
      this.parameters.q = this.searchTarget.value;
    }

    this.filterDebounced = debounce(this.filter.bind(this), 500);
    this.filterSearchDebounced = debounce(this.filter.bind(this), 300);

    this.filterDebounced();
  }

  onFilterChange() {
    this.filterDebounced();
  }

  onSearchChange(e) {
    e.target.value = e.target.value.replace(/(<([^>]+)>)/ig, '');

    this.filterSearchDebounced();

    this.parameters.q = e.target.value;
  }

  onSortChange(e) {
    const currentTarget = e.target;

    this.sortTargets.forEach((target) => target.classList.remove('is-active'));
    this.parameters.sort = currentTarget.dataset.value;
    this.parameters.direction = currentTarget.dataset.direction;
    currentTarget.classList.add('is-active');

    this.filterDebounced();
  }

  onDisplayChange(e) {
    const currentTarget = e.target;

    this.displayTargets.forEach((target) => target.classList.remove('is-active'));
    this.parameters.display = currentTarget.dataset.value;
    currentTarget.classList.add('is-active');

    this.filterDebounced();
  }

  filter() {
    this.emptyResults();
    this.toggleSpinner(true);

    const parameters = $.param(this.parameters);
    const canonical = document.querySelector('link[rel="canonical"]').href;

    if (hasHistorySupport()) {
      const url = `${canonical}${parameters ? '?' : ''}${parameters}`;
      window.history.replaceState(null, null, url);
    }

    $.get(`${this.API_URL}?${parameters}`)
      .then((res) => {
        this.toggleSpinner(false);
        this.resultsTarget.innerHTML = res.items;
      });
  }

  emptyResults() {
    this.resultsTarget.innerHTML = '';
  }

  toggleSpinner(state) {
    this.spinnerTarget.style.display = state ? 'block' : 'none';
  }
}

FilterController.targets = [
  'form',
  'spinner',
  'results',
  'display',
  'sort',
  'search',
];

export default FilterController;
